import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import axiosHttp from "../../services/interceptor.service";
import { setAuthToken } from "../../services/interceptor.service";
import { useAuth } from "../../context/AuthProvider";

const SSOLogin = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("token");
    // type=user → employee SSO from the Time-Logger desktop app (Dashboard button).
    // Anything else (default) → the original CLIENT SSO flow.
    const type = searchParams.get("type");
    const isUser = type === "user";
    const { commonLogin } = useAuth(); // We might need to manually set state if commonLogin doesn't fit

    useEffect(() => {
        const handleSSO = async () => {
            if (!token) {
                ToastError("No SSO token provided");
                navigate("/login");
                return;
            }

            try {
                const endpoint = isUser
                    ? "/lmt/userLoginByToken"
                    : "/lmt/clientLoginByToken";
                const response = await axiosHttp.post(endpoint, {
                    tokenData: token,
                });

                if (response && !response.error) {
                    const { accessToken, userId } = response.data;

                    localStorage.setItem("token", accessToken);
                    localStorage.setItem("userId", userId);
                    setAuthToken(accessToken);

                    // Reload into the landing page so every context picks up the new
                    // token from localStorage on init. Employees land on the dashboard;
                    // clients keep their task-management landing.
                    window.location.href = isUser
                        ? "/home/dashboard"
                        : "/home/clientTaskManagement";

                    ToastSuccess("Login Successful");
                } else {
                    ToastError(response.message || "Login Failed");
                    navigate("/login");
                }
            } catch (error) {
                console.error("SSO Error:", error);
                ToastError(error?.response?.data?.message || "Login Failed");
                navigate("/login");
            }
        };

        handleSSO();
    }, [token, navigate, isUser]);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontSize: '20px',
            flexDirection: 'column',
            gap: '20px'
        }}>
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <div>Authenticating...</div>
        </div>
    );
};

export default SSOLogin;
